import { SvgIconProps } from '@mui/material';

import {
  CheckboxIcon,
  DateIcon,
  EmailIcon,
  LinkIcon,
  LocationIcon,
  MultiSelectIcon,
  NumberIcon,
  PhoneIcon,
  TextIcon,
} from 'src/components/icons';
import { CustomFieldType } from 'src/store/clients/types';

interface FieldValidation {
  invalidText: string;
}

interface FieldDefaultProps {
  icon: (props: SvgIconProps) => JSX.Element;
  placeholder: string;
  validation?: FieldValidation;
}

export const MapFieldTypeToDefaultProps = {
  phoneNumber: {
    icon: PhoneIcon,
    placeholder: 'Add a phone number',
    validation: {
      invalidText: 'Phone number is invalid',
    },
  },
  email: {
    icon: EmailIcon,
    placeholder: 'Add an email',
    validation: {
      invalidText: 'Please enter a valid email',
    },
  },
  url: {
    icon: LinkIcon,
    placeholder: 'Add a URL',
    validation: {
      invalidText: 'Please enter a valid URL',
    },
  },
  text: {
    icon: TextIcon,
    placeholder: 'Add text',
  },
  number: {
    icon: NumberIcon,
    placeholder: 'Add a number',
  },
  address: {
    icon: LocationIcon,
    placeholder: 'Add an address',
  },
  multiSelect: {
    icon: MultiSelectIcon,
    placeholder: 'Add a tag',
  },
  date: {
    icon: DateIcon,
    placeholder: 'Add a date',
  },
  checkbox: {
    icon: CheckboxIcon,
    placeholder: '',
  },
  select: {
    icon: MultiSelectIcon,
    placeholder: 'Select an option',
  },
} satisfies Record<CustomFieldType, FieldDefaultProps>;
